// OwnershipReminder. Mirrors data-component="ownership-reminder"
// from the approved HTML. Read-only reminder that relationship
// records provide context only and never change ownership or
// authorize outreach to the barn, trainer, veterinarian or farrier.
//
// TODO(runtime): hydrate from services/ownership (confirmed service,
// coverage-preserves-ownership rule per the approved HTML).
import type { ReactNode } from 'react';
import type { OwnershipReminder as OwnershipReminderData } from '../mockData.js';

export interface OwnershipReminderProps {
  ownership: OwnershipReminderData;
}

export function OwnershipReminder({ ownership }: OwnershipReminderProps): ReactNode {
  return (
    <section className="gift-followup" data-component="ownership-reminder">
      <span className="owner-avatar">{ownership.repInitials}</span>
      <div>
        <strong>{ownership.repName} &middot; Primary rep</strong>
        <p>{ownership.message}</p>
        <small>{ownership.lastTouch}</small>
      </div>
    </section>
  );
}
